import { render, staticRenderFns } from "./ServiceNei.vue?vue&type=template&id=185ef8ac&scoped=true"
import script from "./ServiceNei.vue?vue&type=script&lang=js"
export * from "./ServiceNei.vue?vue&type=script&lang=js"
import style0 from "./ServiceNei.vue?vue&type=style&index=0&id=185ef8ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ef8ac",
  null
  
)

export default component.exports